import { DEFAULT_LOCATIONS, STANLEY_BLACK_AND_DECKER, CHECKMARK } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 1806a33b73a833695106d996af7711789bc0e82b',
  staging: 'Token 577e9ac2368f6bfc880bfed7aef1e21a4958e60e',
  prod: 'Token 88999256425e7ee7e5654fbb035e2207fbaf97d5',
};

const token = selectToken(apiTokens);

const stanleyBlackAndDeckerConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'sbd-cigna',

  API_TOKEN: token,
  EMBOLD_CLIENT: STANLEY_BLACK_AND_DECKER,

  // login
  SHOW_REGION_SELECTOR: false,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.NewBritain },
  LOGIN_NETWORK_NAME: 'stanleyBlackAndDeckerUserId',

  // content
  DISPLAY_NAME: 'Stanley Black & Decker',
  FORM_VARIANT: CHECKMARK,
  NO_WELCOME_LINK: false,
};

export default stanleyBlackAndDeckerConfig;
